import { createContext } from "react";
import {
  ActiveComponent,
  ActiveComponentGroup,
  CurrentLocaleModel,
  Product,
  VTGComponent,
} from "./types";

export * from "./types";

export interface DataContainerContextState {
  data: Product[];
  currentLocale: CurrentLocaleModel | undefined;
  setCurrentLocale: (locale: CurrentLocaleModel) => void;
  activeComponent: ActiveComponent;
  activeComponentGroups: ActiveComponentGroup;
  activeComponentIndex: number;
  setActiveComponentIndex: (index: number | ((i: number) => number)) => void;
  allComponents: VTGComponent[];
  goNext: () => boolean;
  goBack: () => boolean;
  jumpToGroup: (group: string | number) => void;
  jumpToComponent: (componentName: string) => void;
  modelName: string;
  setModelName: (model: string) => void;
  searchParams: any;
  setSearchParams: (params: any) => void;
  defaultVariantColor: string;
  setDefaultVariantColor: (color: string) => void;
  isColorComingFromURL: boolean;
  setIsColorComingFromURL: (isColor: boolean) => void;
  setProductDataLoaded: (isLoaded: boolean) => void;
}

export const defaultDataContainerContextState: DataContainerContextState = {
  data: [],
  currentLocale: undefined,
  setCurrentLocale: () => undefined,
  activeComponent: { name: "", componentId: 0, index: 0 },
  activeComponentGroups: { name: "", id: 0, index: 0 },
  activeComponentIndex: 0,
  setActiveComponentIndex: () => undefined,
  allComponents: [],
  goNext: () => false,
  goBack: () => false,
  jumpToGroup: () => undefined,
  jumpToComponent: () => undefined,
  modelName: "",
  setModelName: () => undefined,
  searchParams: undefined,
  setSearchParams: () => undefined,
  defaultVariantColor: "",
  setDefaultVariantColor: () => undefined,
  isColorComingFromURL: false,
  setIsColorComingFromURL: () => undefined,
  setProductDataLoaded: () => undefined,
};

export const DataContainerContext = createContext<DataContainerContextState>(
  defaultDataContainerContextState
);
